import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Colors } from '@vetahealth/fishing-gear/colors'
import React, { useEffect } from 'react'
import Animated, {
  cancelAnimation,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import { Icon } from '../Icon'

export function PulsatingIcon({
  icon,
  size = 80,
  color = Colors.mauve300,
  isPaused,
}: {
  icon: IconProp
  size?: number
  color?: Colors
  isPaused?: boolean
}): React.ReactNode {
  const animation = useSharedValue(0)

  const style = useAnimatedStyle(() => ({
    transform: [{ scale: interpolate(animation.value, [0, 1], [1, 0.9]) }],
  }))

  useEffect(() => {
    if (isPaused) {
      cancelAnimation(animation)
      animation.value = withTiming(0, { duration: 500 })
    } else {
      animation.value = withRepeat(withTiming(1, { duration: 1000 }), -1, true)
    }
  }, [isPaused])

  return (
    <Animated.View style={style}>
      <Icon icon={icon} size={size} color={color} />
    </Animated.View>
  )
}
